import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';

import { moneyTransferApi } from 'src/Services/API';

interface Options {
  onSuccess?: () => void;
}

export const useDeleteMoneyTransfer = (options?: Options) => {
  const { assetId } = useParams<{ assetId: string }>();
  const queryClient = useQueryClient();

  return useMutation(
    (transferId: string) => {
      if (!assetId) throw new Error('Asset ID is missing');
      return moneyTransferApi.delete(assetId, transferId);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['money-transfers', assetId]);
        queryClient.invalidateQueries(['expenses', assetId]);
        queryClient.invalidateQueries(['fetch-expenses', assetId]); // Refresh expense list (reimbursement status)
        queryClient.invalidateQueries(['fetch-expense-balance', assetId]);
        queryClient.invalidateQueries(['fetch-personal-wallet', assetId]);
        queryClient.invalidateQueries(['asset-stats', assetId]);
        options?.onSuccess?.();
      },
    }
  );
};
